// @flow
import styled from 'styled-components';

export const StyledCloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
  border-radius: 2px;
  padding: 0.6rem;

  &:focus {
    outline: none;
  }
`;
